import { Epic, ofType } from "redux-observable";
import { RootState } from "../../store";
import * as authSelectors from "../auth/authSelectors";
import * as actions from "./memberCardPoolActions";
import { ServiceContainer } from "../../serviceContainer";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { of } from "rxjs";

export const memberCardPoolsEpic: Epic<
  any,
  any,
  RootState,
  ServiceContainer
> = (action$, state$, services) =>
  action$.pipe(
    ofType(actions.GET_MEMBER_CARD_POOLS),
    exhaustMap((action: actions.GetMemberCardPoolsAction) => {
      const state = state$.value;

      return services.apiMemberCardPool
        .listForOrganization(
          authSelectors.accessToken(state),
          action.organization
        )
        .pipe(
          map((response) => {
            return actions.getMemberCardPoolsSuccessAction(
              action.organization,
              response.member_card_pools
            );
          }),
          catchError(() => {
            services.toastr.error(
              "Fail",
              "There was error while fetching member card pools"
            );
            return of(
              actions.getMemberCardPoolsFailAction(action.organization)
            );
          })
        );
    })
  );
